export default __webpack_public_path__ + "static/media/logo_only.914f8b4a.svg";